import { render, staticRenderFns } from "./CurrentPaidGoods.vue?vue&type=template&id=04247819&scoped=true&"
import script from "./CurrentPaidGoods.vue?vue&type=script&lang=js&"
export * from "./CurrentPaidGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04247819",
  null
  
)

export default component.exports